import { CountryCode, parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';

import { ILocation } from '../../../types';

import isoCountries from './isoCountries';

const validatePhoneNumber = (number: string, currentLocation: ILocation | null) => {
  const processedPhoneNumber = {
    isValid: false,
    country: '',
    number: number,
  };
  let phoneNumberValidity: PhoneNumber;
  try {
    phoneNumberValidity = parsePhoneNumber(number);
    processedPhoneNumber.isValid = phoneNumberValidity.isValid();
    processedPhoneNumber.country = phoneNumberValidity.countryCallingCode;
    processedPhoneNumber.number = phoneNumberValidity.number;
  } catch (error) {
    let country: CountryCode | null = null;
    if (currentLocation) {
      if (currentLocation.countryCode) {
        country = currentLocation.countryCode as CountryCode;
      } else if (currentLocation.country) {
        for (const code in Object.values(isoCountries)) {
          if (code === currentLocation.country) {
            country = code as CountryCode;
          }
        }
      }
    }

    if (country) {
      try {
        phoneNumberValidity = parsePhoneNumber(number, country);
        processedPhoneNumber.isValid = phoneNumberValidity.isValid();
        processedPhoneNumber.country = phoneNumberValidity.countryCallingCode;
        processedPhoneNumber.number = phoneNumberValidity.number;
      } catch (err) {
        console.log('Exception in handle validity', err);
      }
    }
  }

  return processedPhoneNumber;
};

export default validatePhoneNumber;
